import React from "react";
import imageKozijn from '../../../images/situation/maten/kozijn/T.jpg';
import imageMuur from '../../../images/situation/maten/muur/T.jpg';
import PropTypes from "prop-types";

MaatT.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    isMuurMontage: PropTypes.bool.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function MaatT(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u de maat tussen muur en luik invullen.<br/>
        </div>
        <div className="phone-situation-description">
            {props.isMuurMontage
                ? <>Voor muurmontage zal dit een "pasmaat" zijn, bijvoorbeeld 5mm.</>
                : <>Om de inschroefduim in het kozijn te kunnen draaien, moet dit in het algemeen meer zijn dan 45mm.</>}
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={props.isMuurMontage ? imageMuur : imageKozijn} alt=""/>
    </div>;
}